import React from "react";
import { Barras, COLORES, Columnas, Kpis, Pagina, Tabla, Tarjeta, fmtM, fmtN, fmtP, useDatos, usePeriodo } from "./comun";

function ReporteImpuestos() {
  const periodo = usePeriodo();
  const { datos: d, error } = useDatos(`/impuestos/${periodo.inicio}/${periodo.fin}`);
  const k = d?.kpis;
  return (
    <Pagina titulo="IEPS e IVA" subtitulo="Impuestos trasladados en las notas de venta. Informativo: no sustituye al calculo fiscal" periodo={periodo} error={error} cargando={!d}>
      {d && <>
        <Kpis items={[{ t: "IEPS", v: fmtM(k.ieps) }, { t: "IVA", v: fmtM(k.iva) }, { t: "Base de venta", v: fmtM(k.base) }, { t: "Tasa IEPS efectiva", v: fmtP(k.tasaEfectiva) }]} />
        <div className="rp-grid">
          <Tarjeta titulo="IEPS e IVA por mes" ancho>
            <Columnas datos={d.meses} series={[{ key: "ieps", label: "IEPS", color: COLORES[0] }, { key: "iva", label: "IVA", color: COLORES[1] }]} />
          </Tarjeta>
          <Tarjeta titulo="IEPS por tasa">
            <Tabla filas={d.porTasa} columnas={[{ t: "Tasa", k: "nombre" }, { t: "Botellas", k: "botellas", f: fmtN, n: 1 }, { t: "Base", k: "base", f: fmtM, n: 1 }, { t: "IEPS", k: "ieps", f: fmtM, n: 1 }]} />
          </Tarjeta>
          <Tarjeta titulo="IEPS por tipo de vino"><Barras datos={d.porTipo} valor="ieps" /></Tarjeta>
        </div>
      </>}
    </Pagina>
  );
}
export default ReporteImpuestos;
